import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSlots = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 4.25a.75.75 0 0 0-.75.75v14c0 .414.336.75.75.75h14a.75.75 0 0 0 .75-.75v-1.25H20a.75.75 0 0 0 .75-.75v-6.378a2.251 2.251 0 1 0-2-3.993V5a.75.75 0 0 0-.75-.75zm14.75 6.121v5.879h.5v-5.628a2.2 2.2 0 0 1-.5-.25M20 9.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M17.25 17v1.25H4.75v-2.5h12.5V17m0-8.25h-3.5V12a.75.75 0 0 1-1.5 0V8.75h-2.5V12a.75.75 0 0 1-1.5 0V8.75h-3.5v5.5h12.5zm0-1.5v-1.5H4.75v1.5h12.5"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSlots;
